import React, { Fragment, useState } from 'react'
import { Paper, Typography } from '@mui/material';

import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import { useDispatch, useSelector } from 'react-redux'
import {
    actualizarFC_06Estatus,
    obtenerIdCliente,
    agregarMapFC_06Accion,
    resetDataFC_06,
    guardarCambiosFC_06Solicitud, agregarFC_06AnexoPredio,
    actualizarFC_06Solicitud, actualizarFC_06MapSolicitud,
    obtenerSolicitudDetalleFC_06ConMaps, aceptarSolicitudFC_06,
    generarDocumentosFC_06
} from '../../../redux/DucksAtencionACliente/FC_06AtencionAClienteDucks'
import { AcualizarFormatoAccion } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import TablaAtencionACliente from './TablaAtencionACliente';
import estilos from './AtencionAClientesFC_06Component.module.css'; { {/*Estilos para el componente*/ } }
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
const { useEffect, useRef } = React;
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 290,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function FC_06Component(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)

    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const formato = useSelector(store => store.AtencionSolicitud.formato)
    const idUsuario = usuario.data.user[0].id
    const dataUser = useSelector(store => store.Usuario.user)
    let fc_06 = useSelector(store => store.FC_06SolicitudAtencionACliente.fc_06)
    let fc_06Predios = useSelector(store => store.FC_06SolicitudAtencionACliente.predios)
    let solicitud = useSelector(store => store.FC_06SolicitudAtencionACliente.data)
    let fc_06Map = useSelector(store => store.FC_06SolicitudAtencionACliente.fc_06Map)
    let fc_06PrediosMap = useSelector(store => store.FC_06SolicitudAtencionACliente.prediosMap)
    let fc_06ViverosMap = useSelector(store => store.FC_06SolicitudAtencionACliente.viverosMap)
    const currentUser = useSelector(store => store.Usuario.data)
    let filesPrediosMap = useSelector(store => store.FC_06SolicitudAtencionACliente.filesPrediosMap)
    let filesViverosMap = useSelector(store => store.FC_06SolicitudAtencionACliente.filesViverosMap)

    var fechaHoy = moment().format('YYYY-MM-DD');
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3])
    const modoVerDetalle = useSelector(store => store.FC_06SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Predios/Viveros', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    let pagina1 = []
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliosolicitante, idfc06_registromaguey: solicitud.idfc06_registromaguey,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.domiciliosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? !fc_06Map?.domiciliosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.domiciliosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Nombre del Responsable de Campo', valor: solicitud.nombreresponsable, idfc06_registromaguey: solicitud.idfc06_registromaguey,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.nombreresponsable : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? !fc_06Map?.nombreresponsablecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.nombreresponsablecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc06_registromaguey: solicitud.idfc06_registromaguey,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? !fc_06Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.telefonocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.email, idfc06_registromaguey: solicitud.idfc06_registromaguey,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.email : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? !fc_06Map?.emailcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.emailcheck : false,
        },
        {
            id: uuidv4(), Campo: 'Predio', valor: solicitud.predio ? 'Si' : 'No', idfc06_registromaguey: solicitud.idfc06_registromaguey,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.predio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? !fc_06Map?.prediocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.prediocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Vivero', valor: solicitud.vivero ? 'Si' : 'No', idfc06_registromaguey: solicitud.idfc06_registromaguey,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.vivero : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? !fc_06Map?.viverocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_06Map) && JSON.stringify([]) !== JSON.stringify(fc_06Map) ? fc_06Map?.viverocheck : false,
        }
    )
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)

    let documentacionPrediosViveros = []
    const productor = []
    let nameViveroPredio = ''
    if (solicitud?.fc_06_anexopredio?.length !== 0) {
        nameViveroPredio = 'DOCUMENTACIÓN DE PREDIOS'
        documentacionPrediosViveros.push({ id: uuidv4(), nameDoc: nameViveroPredio })
    }

    for (const index in solicitud.fc_06_anexopredio) {
        const { ...prop } = solicitud.fc_06_anexopredio[index]
        documentacionPrediosViveros.push({ id: uuidv4(), nameDoc: 'Documentación de predio: ' + prop.nombreparaje })
        const arrayDocumentacion = []
        for (const i in prop.fc_06archivospredio) {
            const documentacion = {
                tabla: 'fc_06archivospredio',
                nombreId: 'idfc06_anexopredio',
                idSolicitud: prop.fc_06archivospredio[i].idfc06_anexopredio,
                nameid: prop.fc_06archivospredio[i].nameid,
            }
            const nameId = prop.fc_06archivospredio[i].nameid
            let nameDoc = ''
            if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
            else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
            else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
            else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
            else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
            else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
            else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
            else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

            let filtro = filesPrediosMap.filter(anexo => anexo.idfc_06archivospredio === prop.fc_06archivospredio[i].idfc_06archivospredio)
            arrayDocumentacion.push(documentacion)
            documentacionPrediosViveros.push({
                id: uuidv4(),
                observaciones: filtro?.[0] ? filtro?.[0]?.observacion : '',
                correcto: filtro?.[0] ? !filtro?.[0]?.estatuscheck : false,
                incorrecto: filtro?.[0] ? filtro?.[0]?.estatuscheck : false,
                fechaInicio: prop.fc_06archivospredio[i].fechainicio !== null ? prop.fc_06archivospredio[i].fechainicio : '',
                fechaTermino: prop.fc_06archivospredio[i].fechafin !== null ? prop.fc_06archivospredio[i].fechafin : '',
                estatus: prop.fc_06archivospredio[i].estatus !== null ? prop.fc_06archivospredio[i].estatus : 'Agregar',
                idMap: filtro?.[0]?.idfc_06archivosprediomap ? filtro?.[0]?.idfc_06archivosprediomap : '',
                tabla: 'fc_06archivospredio',
                nombreId: 'idfc06_anexopredio', idSolicitud: prop.fc_06archivospredio[i].idfc06_anexopredio, nameid: nameId, nameDoc: nameDoc + ' del paraje: ' + prop.nombreparaje,
                idAnexo: prop.fc_06archivospredio[i].idfc_06archivospredio
            })
        }
        let primeraLetra = prop.nombreparaje.charAt(0).toUpperCase()
        let cadena = primeraLetra + prop.nombreparaje.substring(1, prop.nombreparaje.length)
        productor.push({
            id: uuidv4(), valor: 'PREDIO: ' + cadena, align: 'center'
        })
        let filtro = fc_06PrediosMap?.filter(anexo => anexo?.idfc06_anexopredio === prop?.idfc06_anexopredio)
        productor.push({
            id: uuidv4(), idfc06_anexopredio: prop.idfc06_anexopredio, Campo: `Domicilio`, valor: prop.localidad + ';' + prop.municipio + ';' + prop.distrito + ';' + prop.estado,
            observaciones: filtro?.[0] ? filtro?.[0]?.domicilio : '',
            correcto: filtro?.[0] ? !filtro?.[0]?.domiciliocheck : false,
            incorrecto: filtro?.[0] ? filtro?.[0]?.domiciliocheck : false,
            idMap: filtro?.[0] ? filtro?.[0].idfc06_anexoprediomap : '',
            arrayDocumentacion
        })
    }
    let [rowspagina2, setrowspagina2] = React.useState([...productor])
    const vivero = []
    let nameVivero = ''
    if (solicitud?.fc_06_anexovivero?.length !== 0) {
        nameVivero = 'DOCUMENTACIÓN DE VIVERISTA'
        documentacionPrediosViveros.push({ id: uuidv4(), nameDoc: nameVivero })
    }



    for (const index in solicitud.fc_06_anexovivero) {
        const { ...prop } = solicitud.fc_06_anexovivero[index]
        documentacionPrediosViveros.push({ id: uuidv4(), nameDoc: 'Documentación de vivero: ' + prop.nombreparaje })
        const arrayDocumentacion = []
        for (const i in prop.fc_06archivosvivero) {
            const documentacion = {
                tabla: 'fc_06archivosvivero',
                nombreId: 'idfc06_anexopredio',
                idSolicitud: prop.fc_06archivosvivero[i].idfc06_anexopredio,
                nameid: prop.fc_06archivosvivero[i].nameid,
            }
            const nameId = prop.fc_06archivosvivero[i].nameid
            let nameDoc = ''
            if ((nameId).includes('COPIAESC')) nameDoc = 'Copia de escritura'
            else if ((nameId).includes('CONSPOS')) nameDoc = 'Constancia de posesión'
            else if ((nameId).includes('CONARREN')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVARREN')) nameDoc = 'Identificación oficial vigente de arrendador'
            else if ((nameId).includes('IOVCOMPR')) nameDoc = 'Identificación oficial vigente de comprador'
            else if ((nameId).includes('CONCOMPR')) nameDoc = 'Contrato de compraventa'
            else if ((nameId).includes('CONCOMODA')) nameDoc = 'Contrato de comodato'
            else if ((nameId).includes('IOVCOMTE')) nameDoc = 'Identificación oficial vigente de comodante'
            else if ((nameId).includes('IOVCOMRIO')) nameDoc = 'Identificación oficial vigente de comodatario'

            arrayDocumentacion.push(documentacion)
            let filtro = filesViverosMap.filter(anexo => anexo.idfc_06archivosvivero === prop.fc_06archivosvivero[i].idfc_06archivosvivero)

            documentacionPrediosViveros.push({
                id: uuidv4(),
                observaciones: filtro?.[0] ? filtro?.[0]?.observacion : '',
                correcto: filtro?.[0] ? !filtro?.[0]?.estatuscheck : false,
                incorrecto: filtro?.[0] ? filtro?.[0]?.estatuscheck : false,
                fechaInicio: prop.fc_06archivosvivero[i].fechainicio !== null ? prop.fc_06archivosvivero[i].fechainicio : '',
                fechaTermino: prop.fc_06archivosvivero[i].fechafin !== null ? prop.fc_06archivosvivero[i].fechafin : '',
                estatus: prop.fc_06archivosvivero[i].estatus !== null ? prop.fc_06archivosvivero[i].estatus : 'Agregar',
                idMap: filtro?.[0] ? filtro?.[0]?.idfc_06archivosviveromap : '',
                tabla: 'fc_06archivosvivero',
                nombreId: 'idfc06_anexovivero', idSolicitud: prop.fc_06archivosvivero[i].idfc06_anexovivero, nameid: nameId, nameDoc: nameDoc + ' del paraje: ' + prop.nombreparaje,
                idAnexo: prop.fc_06archivosvivero[i].idfc_06archivosvivero
            })
        }
        let primeraLetra = prop.nombreparaje.charAt(0).toUpperCase()
        let cadena = primeraLetra + prop.nombreparaje.substring(1, prop.nombreparaje.length)
        vivero.push({
            id: uuidv4(), valor: 'VIVERO: ' + cadena, align: 'center'
        })
        let filtro = fc_06ViverosMap?.filter(anexo => anexo?.idfc06_anexovivero === prop?.idfc06_anexovivero)
        vivero.push({
            id: uuidv4(), idfc06_anexovivero: prop.idfc06_anexovivero, Campo: `Domicilio`, valor: prop.calle + ';' + prop.numeroexterior + ';' + prop.codigopostal + ';' + prop.localidad
                + ';' + prop.municipio + ';' + prop.distrito + ';' + prop.estado,
            observaciones: filtro?.[0] ? filtro?.[0]?.domicilio : '',
            correcto: filtro?.[0] ? !filtro?.[0]?.domiciliocheck : false,
            incorrecto: filtro?.[0] ? filtro?.[0]?.domiciliocheck : false,
            idMap: filtro?.[0]?.idfc06_anexoviveromap ? filtro?.[0]?.idfc06_anexoviveromap : '',
            arrayDocumentacion
        })

        // contPredio++
    }
    let [rowspagina22, setrowspagina22] = React.useState([...vivero])
    let [rowspagina4, setrowspagina4] = React.useState([...documentacionPrediosViveros])
    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroPredio = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroVivero = rowspagina22.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina4.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroPredio !== -1) {
            rowspagina2[filtroPredio].valor = objectProducto.valor
            rowspagina2[filtroPredio].correcto = objectProducto.correcto
            rowspagina2[filtroPredio].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroPredio].observaciones = objectProducto.observaciones
        }
        if (filtroVivero !== -1) {
            rowspagina22[filtroVivero].valor = objectProducto.valor
            rowspagina22[filtroVivero].correcto = objectProducto.correcto
            rowspagina22[filtroVivero].incorrecto = objectProducto.incorrecto
            rowspagina22[filtroVivero].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            rowspagina4[filtroDocumentacion].valor = objectProducto.valor
            rowspagina4[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina4[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina4[filtroDocumentacion].observaciones = objectProducto.observaciones
        }
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_06Map) || JSON.stringify([]) === JSON.stringify(fc_06Map) || fc_06Map === null) {
            await agregarMapYActualizarFC_06()
            const idSolicitud = solicitud.idfc06_registromaguey
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_06 = 2
            const tabla = tablaFC_06
            await dispatch(actualizarFC_06Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_06()
            const idSolicitud = solicitud.idfc06_registromaguey
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_06 = 2
            const tabla = tablaFC_06
            await dispatch(actualizarFC_06Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const agregarMapYActualizarFC_06 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc06_registromaguey: rowspagina1[0].idfc06_registromaguey,
            nombreresponsable: rowspagina1[1].valor, telefono: rowspagina1[2].valor,
            email: rowspagina1[3].valor,
            fechasolicitud: fechaSolicitudAceptada
        })

        let principalMap = []
        principalMap.push({
            nombreresponsable: rowspagina1[1].observaciones,
            telefono: rowspagina1[2].observaciones,
            email: rowspagina1[3].observaciones,
            predio: rowspagina1[4].observaciones,
            vivero: rowspagina1[5].observaciones,

            nombreresponsablecheck: rowspagina1[1].incorrecto,
            telefonocheck: rowspagina1[2].incorrecto,
            emailcheck: rowspagina1[3].incorrecto,
            prediocheck: rowspagina1[4].incorrecto,
            viverocheck: rowspagina1[5].incorrecto,
            idfc06_registromaguey: solicitud.idfc06_registromaguey,
        })

        const predios = []
        const prediosMap = []
        for (const datos of rowspagina2) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                predios.push({ idfc06_anexopredio: datos.idfc06_anexopredio, localidad: domicilio[0], municipio: domicilio[1], distrito: domicilio[2], estado: domicilio[3] })
                prediosMap.push({ idfc06_anexopredio: datos.idfc06_anexopredio, domicilio: datos.observaciones, domiciliocheck: datos.incorrecto })
            }
        }
        const vivero = []
        const viveroMap = []
        for (const datos of rowspagina22) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                vivero.push({
                    idfc06_anexovivero: datos.idfc06_anexovivero, calle: domicilio[0], numeroexterior: domicilio[1], codigopostal: domicilio[2], localidad: domicilio[3],
                    municipio: domicilio[4], distrito: domicilio[5], estado: domicilio[6]
                })
                viveroMap.push({ idfc06_anexovivero: datos.idfc06_anexovivero, domicilio: datos.observaciones, domiciliocheck: datos.incorrecto })
            }
        }
        const archivosVivero = []
        const archivosViveroMap = []
        const archivosPredio = []
        const archivosPredioMap = []
        for (const datos of rowspagina4) {
            if (datos.tabla === 'fc_06archivospredio') {
                let fechaInicio = ''
                let fechaFin = ''
                if (datos.fechaInicio.length > 0) fechaInicio = new Date(datos.fechaInicio).toISOString()
                else fechaInicio = null
                if (datos.fechaTermino.length > 0) fechaFin = new Date(datos.fechaTermino).toISOString()
                else fechaFin = null

                archivosPredio.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_06archivospredio: datos.idAnexo, estatus: datos.estatus
                })
                archivosPredioMap.push({
                    idfc_06archivospredio: datos.idAnexo, estatuscheck: datos.incorrecto,
                    observacion: datos.observaciones,
                })
            }
            if (datos.tabla === 'fc_06archivosvivero') {
                let fechaInicio = ''
                let fechaFin = ''
                if (datos.fechaInicio.length > 0) fechaInicio = new Date(datos.fechaInicio).toISOString()
                else fechaInicio = null
                if (datos.fechaTermino.length > 0) fechaFin = new Date(datos.fechaTermino).toISOString()
                else fechaFin = null

                archivosVivero.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_06archivosvivero: datos.idAnexo, estatus: datos.estatus
                })
                archivosViveroMap.push({
                    idfc_06archivosvivero: datos.idAnexo, estatuscheck: datos.incorrecto,
                    observacion: datos.observaciones,
                })
            }
        }

        let formato = { solicitud: principal[0], predio: predios, vivero: vivero, archivosPredio: archivosPredio, archivosVivero: archivosVivero }
        let formatoMap = { solicitud: principalMap, prediosMap: prediosMap, viveroMap: viveroMap, archivosPredioMap: archivosPredioMap, archivosViveroMap: archivosViveroMap }
        await dispatch(agregarMapFC_06Accion(formatoMap))
        await dispatch(actualizarFC_06Solicitud(formato))
        return
    }
    const actualizarMapYActualizarFC_06 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc06_registromaguey: rowspagina1[0].idfc06_registromaguey,
            nombreresponsable: rowspagina1[1].valor, telefono: rowspagina1[2].valor,
            email: rowspagina1[3].valor,
            fechasolicitud: fechaSolicitudAceptada
        })

        let principalMap = []
        principalMap.push({
            idfc06_registromagueymap: fc_06Map.idfc06_registromagueymap,
            nombreresponsable: rowspagina1[1].observaciones,
            telefono: rowspagina1[2].observaciones,
            email: rowspagina1[3].observaciones,
            predio: rowspagina1[4].observaciones,
            vivero: rowspagina1[5].observaciones,

            nombreresponsablecheck: rowspagina1[1].incorrecto,
            telefonocheck: rowspagina1[2].incorrecto,
            emailcheck: rowspagina1[3].incorrecto,
            prediocheck: rowspagina1[4].incorrecto,
            viverocheck: rowspagina1[5].incorrecto,
            idfc06_registromaguey: solicitud.idfc06_registromaguey,
        })

        const predios = []
        const prediosMap = []
        for (const datos of rowspagina2) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                predios.push({ idfc06_anexopredio: datos.idfc06_anexopredio, localidad: domicilio[0], municipio: domicilio[1], distrito: domicilio[2], estado: domicilio[3] })
                prediosMap.push({
                    idfc06_anexopredio: datos.idfc06_anexopredio, domicilio: datos.observaciones,
                    domiciliocheck: datos.incorrecto, idfc06_anexoprediomap: datos.idMap
                })
            }
        }
        const vivero = []
        const viveroMap = []
        for (const datos of rowspagina22) {
            if (datos.Campo) {
                let domicilio = datos.valor.split(';')
                vivero.push({
                    idfc06_anexovivero: datos.idfc06_anexovivero, calle: domicilio[0], numeroexterior: domicilio[1], codigopostal: domicilio[2], localidad: domicilio[3],
                    municipio: domicilio[4], distrito: domicilio[5], estado: domicilio[6]
                })
                viveroMap.push({
                    idfc06_anexovivero: datos.idfc06_anexovivero, domicilio: datos.observaciones,
                    domiciliocheck: datos.incorrecto, idfc06_anexoviveromap: datos.idMap
                })
            }
        }
        const archivosVivero = []
        const archivosViveroMap = []
        const archivosPredio = []
        const archivosPredioMap = []
        for (const datos of rowspagina4) {
            if (datos.tabla === 'fc_06archivospredio') {
                let fechaInicio = ''
                let fechaFin = ''
                if (datos.fechaInicio.length > 0) fechaInicio = new Date(datos.fechaInicio).toISOString()
                else fechaInicio = null
                if (datos.fechaTermino.length > 0) fechaFin = new Date(datos.fechaTermino).toISOString()
                else fechaFin = null

                archivosPredio.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_06archivospredio: datos.idAnexo, estatus: datos.estatus
                })
                archivosPredioMap.push({
                    idfc_06archivospredio: datos.idAnexo, estatuscheck: datos.incorrecto,
                    observacion: datos.observaciones, idfc_06archivosprediomap: datos.idMap
                })
            }
            if (datos.tabla === 'fc_06archivosvivero') {
                let fechaInicio = ''
                let fechaFin = ''
                if (datos.fechaInicio.length > 0) fechaInicio = new Date(datos.fechaInicio).toISOString()
                else fechaInicio = null
                if (datos.fechaTermino.length > 0) fechaFin = new Date(datos.fechaTermino).toISOString()
                else fechaFin = null

                archivosVivero.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_06archivosvivero: datos.idAnexo, estatus: datos.estatus
                })
                archivosViveroMap.push({
                    idfc_06archivosvivero: datos.idAnexo, estatuscheck: datos.incorrecto,
                    observacion: datos.observaciones, idfc_06archivosviveromap: datos.idMap
                })
            }
        }

        let formato = { solicitud: principal[0], vivero: vivero, predio: predios, archivosPredio: archivosPredio, archivosVivero: archivosVivero }
        let formatoMap = { solicitud: principalMap, prediosMap: prediosMap, viveroMap: viveroMap, archivosPredioMap: archivosPredioMap, archivosViveroMap: archivosViveroMap }
        await dispatch(actualizarFC_06MapSolicitud(formatoMap))
        await dispatch(actualizarFC_06Solicitud(formato))
        return
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_06())
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            <strong>Aceptar Solicitud</strong>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'justify' }}>
                            Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                            y los datos se tomarán como válidos.
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                            <strong>¿Desea continuar?</strong>
                        </Typography>
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => botonAceptarSolicitud()}>CONTINUAR</button>
                        </div>

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async (dataForm) => {

        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_06Map) || JSON.stringify([]) === JSON.stringify(fc_06Map) || fc_06Map === null) {
            await agregarMapYActualizarFC_06()
        } else {
            await actualizarMapYActualizarFC_06()
        }
        const dataSolicitudFC_06 = await dispatch(obtenerSolicitudDetalleFC_06ConMaps(solicitud.idfc06_registromaguey))
        const solicitudParaAceptar = dataSolicitudFC_06.payload
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        const objetoCompleto = {
            idcliente: dataCliente?.payload?.cliente?.[0]?.idcliente,
            idfc06_registromaguey: solicitud.idfc06_registromaguey,
            predios: solicitudParaAceptar.fc_06_anexopredio,
            viveros: solicitudParaAceptar.fc_06_anexovivero
        }
        await dispatch(aceptarSolicitudFC_06(objetoCompleto))

        await generarOficios(solicitud, dataCliente.payload.cliente[0])

        const idSolicitud = solicitud.idfc06_registromaguey
        const estatusNuevo = 4
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_06 = 2
        const tabla = tablaFC_06
        await dispatch(actualizarFC_06Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_06, dataCliente) => {
        const data = {
            tipoSolicitud: 'FC_06',
            solicitudFC_06,
            dataCliente,
        }
        await dispatch(generarDocumentosFC_06(data))
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> :
                    nombresParaPaginas[paginaActiva - 1] === 'Predios/Viveros' ?
                        <Fragment>
                            {solicitud.predio ? <div className='row justify-content-center'>
                                <div className='col-10'>
                                    <TablaAtencionACliente rows={rowspagina2} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                </div>
                            </div> : ''}
                            {solicitud.vivero ? <div className='row justify-content-center'>
                                <div className='col-10'>
                                    <TablaAtencionACliente rows={rowspagina22} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                </div>
                            </div> : ''}

                        </Fragment>
                        :
                        nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                            <Fragment>
                                <div className='row justify-content-center'>
                                    <div className='col-12' style={{ marginLeft: '7%' }}>
                                        <TablaDocumentacion rows={rowspagina4} api={{ handdleEditPrev }}></TablaDocumentacion>
                                    </div>
                                </div>
                                {modoVerDetalle ?
                                    <div className="row text-center">
                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                        </div>
                                    </div>
                                    :
                                    <div className="row text-center mt-4 mb-4">
                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                        </div>

                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                        </div>
                                    </div>
                                }
                            </Fragment> : ''

            }
            {modalComponentDevolver()}
            {modalComponentAceptar()}
        </Fragment>
    )
}
export default FC_06Component
//export default withRouter(FC_06Component)
